import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { Popover, OverlayTrigger } from "react-bootstrap";

import TraySolutionVendorImage from "components/Tiles/TraySolutionVendorImage";

import getStyles from "components/Home/Utils/getStyles";
import styles from "./style.module.css";

const dataStyles = getStyles("dataset");

export default class SolutionTile extends React.PureComponent {
  renderBody(solution) {
    return (
      <div className={styles.tileBody}>
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top" title={"Recipe Description"}>
              <div className={styles.popList}>
                <div className={styles.popRowMulti}>{solution.description}</div>
              </div>
            </Popover>
          }
        >
          <div className={styles.tileHeaderContent}>
            <div className={styles.tileTriggerWrapper}>
              <div style={{ flexGrow: "0" }} className={styles.tileTriggerText}>
                <TraySolutionVendorImage vendor={solution.vendor} />
              </div>
            </div>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  render() {
    const { solution, isCreating, onClick } = this.props;

    if (!solution) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <div className={styles.tileWrapper}>
        <div
          className={onClick ? styles.tile : styles.tileNoHover}
          onClick={() => {
            if (onClick) {
              return onClick(solution);
            }
          }}
        >
          <div style={{ height: "auto" }} className={styles.tileHeader + " " + styles.recipeBackground}>
            <h1 title={solution.title} className={styles.recipeHeaderText}>
              {solution.title}
            </h1>
            <div className={styles.heroIcons}>{isCreating === true && <LoadingIndicator />}</div>
            {isCreating !== true && this.renderBody(solution)}
          </div>
        </div>
      </div>
    );
  }
}
